import { gtm } from '@lessonnine/marketing-tracker';

import { trackQuestionAnswered } from 'src/dataLayer/remoteData/babbelEventStream';
import { buildValidFlowPath } from 'src/viewLayer/helpers/pathHelpers';
import type { HandleQuestionAnsweredParameterType } from './types';
import type { UserInputType } from '../types.common';

const getUpdatedInput = (
  input: Partial<UserInputType>,
  questionName: string,
  answer: string
): Partial<UserInputType> => ({
  ...input,
  questions: {
    ...input.questions,
    [questionName]: answer
  }
});

export const handleQuestionAnswered = ({
  answer,
  index,
  setUserInput,
  userInput,
  name,
  question,
  options,
  goToNextNode,
  learnLang,
  pathParams,
  queryParams
}: HandleQuestionAnsweredParameterType): void => {
  setUserInput(getUpdatedInput(userInput, name, answer.name));


  const storedUserInput = JSON.parse(localStorage.getItem('userInput')) as UserInputType;

  if (storedUserInput) {
    localStorage.setItem('userInput', JSON.stringify(getUpdatedInput(storedUserInput, name, answer.name)));
  } else {
    localStorage.setItem('userInput', JSON.stringify(getUpdatedInput(userInput, name, answer.name)));
  }

  gtm.trackQuestionAnswered({ question: question.gtm, answer: answer.gtm });
  trackQuestionAnswered({
    learnLang,
    question: question.babbel_tracking,
    answer: answer.babbel_tracking,
    answerPresentationId: question.answer_presentation_id,
    displayRank: index + 1
  });

  const redirectFlowId = options?.redirectionAnswer?.answer === answer.name ?
    options.redirectionAnswer.flowId : undefined;

  if (redirectFlowId) {
    const redirectionParams = { ...pathParams, flowId: redirectFlowId };
    const redirectPath = buildValidFlowPath({ ...redirectionParams, queryParams });
    window.location.assign(redirectPath);
  } else {
    goToNextNode();
  }
};
